/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SearchInputs */

const en_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search seeds`)
};

const th_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาเมล็ด`)
};

const ja_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シードを検索`)
};

const fr_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des graines`)
};

const es_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar semillas`)
};

const ru_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск семян`)
};

const zh_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索种子`)
};

const vi_search = /** @type {(inputs: SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm hạt giống`)
};

/**
* | output |
* | --- |
* | "Search seeds" |
*
* @param {SearchInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const search = /** @type {((inputs?: SearchInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SearchInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_search(inputs)
	if (locale === "ja") return ja_search(inputs)
	if (locale === "fr") return fr_search(inputs)
	if (locale === "es") return es_search(inputs)
	if (locale === "ru") return ru_search(inputs)
	if (locale === "zh") return zh_search(inputs)
	if (locale === "vi") return vi_search(inputs)
	return en_search(inputs)
});